(function () {
    'use strict';

    var COOKIE_NAME = 'loid';
    var COOKIE_DAYS = 30;

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    }

    // 1. Check URL for loid param and store as cookie
    var params = new URLSearchParams(window.location.search);
    var loidParam = params.get('loid');
    if (loidParam) {
        setCookie(COOKIE_NAME, loidParam, COOKIE_DAYS);
        // Remove loid from URL to keep it clean
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('loid');
        window.history.replaceState(null, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    }

    var loid = loidParam || getCookie(COOKIE_NAME);
    if (!loid) return;

    // 2. Set loid as cart attribute so it flows to the order
    fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
            if (!cart.attributes || cart.attributes.loid !== loid) {
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { loid: loid } })
                });
            }
        })
        .catch(function () { });
})();

(function () {
    'use strict';

    var COOKIE_NAME = 'loid';

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    var loid = getCookie(COOKIE_NAME);
    if (!loid) return;

    var discountCode = document.documentElement.getAttribute('data-lo-discount');
    if (!discountCode) return;

    var discountAppliedKey = 'loid_discount_applied';
    if (sessionStorage.getItem(discountAppliedKey) === discountCode) return;

    sessionStorage.setItem(discountAppliedKey, discountCode);
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('loid');
    var redirectPath = currentUrl.pathname + currentUrl.search;
    window.location.href = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(redirectPath);
})();
